// UserStimulusPage.js
import React from "react";
import { Paper, Box, Grid, Typography, Card, CardContent } from "@mui/material";

/**
 * 일반 사용자용 자극 화면
 * props:
 *  - stim: 현재 자극 상태 문자열
 *  - recipePersonal: () => void  (자극 시작)
 *  - endStimulus: () => void      (자극 중지)
 */
export default function UserStimulusPage({
  stim,
  recipePersonal,
  endStimulus,
  remainingTimeSec,
  formatTime,
}) {
  return (
    <Paper
      style={{
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#131313",
      }}
    >
      <Box style={{ color: "#CCCCCC" }}>
        <Box
          style={{
            padding: "0px 10px 30px 10px",
            borderRadius: 5,
            width: "90%",
            marginRight: "5%",
            marginLeft: "5%",
          }}
        >
          <Box sx={{ marginTop: 5 }}>
            <Typography
              sx={{
                fontSize: 25,
                fontFamily: "GmarketSansMedium",
              }}
              color="white"
            >
              자극 상태 : {stim}

              {typeof remainingTimeSec === "number" && formatTime ? (
                <Typography
                  sx={{ fontSize: 22, fontFamily: "GmarketSansMedium", marginTop: 1 }}
                  color="white"
                >
                  남은 시간 : {formatTime(remainingTimeSec)}
                </Typography>
              ) : null}

            </Typography>
            <br />

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Card
                  sx={{
                    width: "90%",
                    backgroundColor: "#393939",
                    cursor: "pointer",
                  }}
                  onClick={recipePersonal}
                >
                  <CardContent>
                    <Typography
                      sx={{
                        fontSize: 20,
                        fontFamily: "GmarketSansMedium",
                        textAlign: "center",
                      }}
                      color="white"
                    >
                      자극 사용
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Card
                  sx={{
                    width: "90%",
                    backgroundColor: "#393939",
                    cursor: "pointer",
                  }}
                  onClick={endStimulus}
                >
                  <CardContent>
                    <Typography
                      sx={{
                        fontSize: 20,
                        fontFamily: "GmarketSansMedium",
                        textAlign: "center",
                      }}
                      color="white"
                    >
                      자극 중지
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
}
